import angular from 'angular';

import '../../core/main/controller/environment';

angular.module("merchant.application.main").factory("merchant.application.main.factory.orderTransaction", [
    "$resource",
    "core.application.main.controller.environment",
    function($resource, Environment) {

        var resource = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/ordertransactions/:orderId", {transactionId: "@transactionId"});
        var resourceSearch = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/ordertransactions/search");
        var resourceRefund = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/ordertransactions/:transactionId/refunds");
        var resourceVoid = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/ordertransactions/:transactionId/void",
            {merchantId: "@merchantId", transactionId: "@transactionId"}, {put: {method: "PUT"}});

        var expose = {};

        expose.populate = function(parameters, success, error) {
            resource.get(parameters, success, error);
        };

        expose.populateOrders = function(parameters, success, error) {
            resourceSearch.get(parameters, success, error);
        };

        expose.refund = function(parameters, postData, success, error) {
            // parameters
            // {
            //     transactionId: "1"
            //     merchantId: "1234"
            // }
            // postData
            // {
            //     amount: {
            //         amount: 120.00,
            //         currency: "AUD"
            //     },
            //     password: "12345abc",
            // }
            new resourceRefund(postData).$save(parameters, success, error);
        };

        expose.void = function(parameters, success, error) {
            resourceVoid.put({
                merchantId: parameters.merchantId,
                transactionId: parameters.transactionId
            }, success, error);
        };

        // Helper function for pages/modules to share scope repopulation
        expose.repopulateOrderForScope = function(scope, data) {
            if (data.channel !== "IN_STORE") {
                // use the shipping address for online and any other orders
                data.address = data.orderDetail && data.orderDetail.shippingAddress;
            }

            var modelLocations = ["order", "paymentSchedule", "orderSummary", "orderHeader",
                "orderRefundList", "orderTotal", "orderProductSummary", "orderDelivery", "orderSettlementSummary",
                "orderSettlementHistoryList", "orderVoidList", "cardOrder"];

            modelLocations.forEach(function(location) {
                scope.model[location] = angular.copy(data);
            });

            scope.model.mapAddress =
              data.address &&
              data.address.address1 + " " +
              (data.address.address2 ? data.address.address2 + " " : "") + // PAYL-6161 ensure google maps can display correctly
              data.address.suburb + " " +
              data.address.state + " " +
              data.address.postcode;
        };

        return expose;

    }
]);
